import api from '@/api';
import { API_BASE_URL } from '..';
import {
  ManifestationRecipientInvoice,
  RecipientInvoiceMaximumNsuQueryFilter,
  RecipientInvoiceQueryFilter,
} from './recipientInvoice.types';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API_BASE_URL}`;

export async function listRecipientInvoice(
  params?: RecipientInvoiceQueryFilter,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/recipient-invoice`,
    params,
  )) as unknown;

  return result as PageResult<ManifestationRecipientInvoice>;
}

export async function maximumNsu(
  params?: RecipientInvoiceMaximumNsuQueryFilter,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/recipient-invoice/last-number-nsu`,
    params,
  )) as unknown;

  return result as number;
}
